import { useOmneoClient } from '@/components/libs/omneo/hooks/useOmneoClient'
import { useEffect, useState } from 'preact/hooks'
import { getAllWishlists } from '../libs/omneo/helpers/getAllWishlists'

/**
 * Wishlist for online (Omneo) use
 */
export const useWishlist = (useCache = true) => {
  const [wishlists, setWishlists] = useState([])
  const { client } = useOmneoClient()

  const optimisticWishlistsUpdate = (wishlistActions) => {
    if (wishlistActions.length > 0) {
      setWishlists((wishlists) => {
        wishlistActions.forEach((a) => {
          const index = wishlists.findIndex((wishlist) => Number(wishlist.id) === Number(a.list.id))
          if (index > -1) {
            if (a.action === 'add') {
              wishlists[index].items.push(a.item)
            } else {
              wishlists[index].items = wishlists[index].items.filter((item) => item.id !== a.item.id)
            }
          }
        })
        return [...wishlists]
      })
    }
  }

  useEffect(() => {
    if (!client || !GM_STATE?.customer?.logged) return

    const updateWishlists = (e) => {
      const cache = e?.detail?.useCache ?? useCache // add useCache to the event to force a refetch
      const wishlistActions = e?.detail?.wishlistActions ?? []
      optimisticWishlistsUpdate(wishlistActions)
      getAllWishlists(client, cache).then((wishlists) => {
        setWishlists(wishlists)
      })
    }

    updateWishlists()
    document.addEventListener('omneo:wishlist:update', updateWishlists)
    return () => {
      document.removeEventListener('omneo:wishlist:update', updateWishlists)
    }
  }, [client])

  return { wishlists }
}
